import { Avatar, Box, Typography } from "@mui/material";
import { User } from "firebase/auth";

interface UserInfoCardProps {
    user: User | null;
}

export default function UserInfoCard({ user }: UserInfoCardProps) {
    return (
        <Box display="flex" alignItems="center" gap={2} mb={3}>
            <Avatar src={user?.photoURL || ""} sx={{ width: 64, height: 64 }} />
            <Typography variant="h5">{user?.displayName || "Пользователь"}</Typography>
        </Box>
    );
}